var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 60,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [_c("span", [_vm._v("Add or Edit Category")])]
            ),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column" }, [
                  _c("label", [_vm._v("Create New Category")]),
                ]),
              ]),
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newCategoryName,
                        expression: "newCategoryName",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder: "Please enter a new Name",
                    },
                    domProps: { value: _vm.newCategoryName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.newCategoryName = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button is-secondary",
                      on: {
                        click: function ($event) {
                          _vm.newCategoryName = ""
                        },
                      },
                    },
                    [_vm._v("Clear")]
                  ),
                ]),
                _c("div", { staticClass: "column" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button is-primary is-pulled-right",
                      on: {
                        click: function ($event) {
                          return _vm.createNewCategory()
                        },
                      },
                    },
                    [_vm._v("Create")]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column" }, [
                  _c("label", [_vm._v("Edit Existing Category")]),
                ]),
              ]),
              _c(
                "draggable",
                {
                  attrs: {
                    list: _vm.categories,
                    group: "categories",
                    handle: ".item-drag-handle",
                    move: _vm.checkMove,
                  },
                  on: {
                    change: (event) => _vm.onImageCategoryOrderChange(event),
                  },
                },
                _vm._l(_vm.categories, function (category, index) {
                  return _c(
                    "div",
                    {
                      key: category.quoteAttachmentCategoryId,
                      staticClass: "field is-horizontal",
                    },
                    [
                      _c("div", { staticClass: "control" }, [
                        _c("span", { staticClass: "icon pt-2" }, [
                          index != 0
                            ? _c("i", {
                                staticClass:
                                  "mdi mdi-drag mdi-24px item-drag-handle",
                                attrs: { "aria-hidden": "true" },
                              })
                            : _vm._e(),
                        ]),
                      ]),
                      _c("div", { staticClass: "field-body" }, [
                        _c("div", { staticClass: "field has-addons" }, [
                          _c("div", { staticClass: "control is-expanded" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: category.name,
                                  expression: "category.name",
                                },
                              ],
                              staticClass: "input",
                              attrs: {
                                type: "text",
                                placeholder: "Existing Name",
                              },
                              domProps: { value: category.name },
                              on: {
                                keyup: function ($event) {
                                  return _vm.setDirty(category)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    category,
                                    "name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-secondary has-text-danger",
                                class: { "is-hidden": category.isDefault },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteCategory(category)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-trash-can mdi-18px",
                                }),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      category.isPrivate
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "control is-flex is-align-items-center pl-3",
                            },
                            [
                              _c("span", { staticClass: "icon" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-eye-off mdi-24px",
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
          _c("footer", { staticClass: "modal-card-foot" }, [
            _c(
              "div",
              {
                style: `width: 100%; display: flex; flex-direction: row-reverse;`,
              },
              [
                _c("div", { staticStyle: { "align-self": "flex-start" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "button tooltip",
                      attrs: { "data-tooltip": "Cancel" },
                      on: {
                        click: function ($event) {
                          return _vm.cancel()
                        },
                      },
                    },
                    [_c("span", [_vm._v("Cancel")])]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary tooltip",
                      attrs: { "data-tooltip": "Save" },
                      on: {
                        click: function ($event) {
                          return _vm.saveCategories()
                        },
                      },
                    },
                    [_c("span", [_vm._v("Save")])]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isDeleteModalActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 60,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isDeleteModalActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [_c("span", [_vm._v("Delete Category")])]
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c("p", [
              _c("span", [
                _vm._v('Proceed to delete category "'),
                _c("span", { staticClass: "has-text-weight-bold" }, [
                  _vm._v(_vm._s(_vm.selectedCategoryName)),
                ]),
                _vm._v('" ?'),
              ]),
            ]),
          ]),
          _c("footer", { staticClass: "modal-card-foot" }, [
            _c(
              "div",
              {
                style: `width: 100%; display: flex; flex-direction: row-reverse;`,
              },
              [
                _c("div", { staticStyle: { "align-self": "flex-start" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "button tooltip",
                      attrs: { "data-tooltip": "Cancel" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDeleteModal()
                        },
                      },
                    },
                    [_c("span", [_vm._v("Cancel")])]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary tooltip",
                      attrs: { "data-tooltip": "Save" },
                      on: {
                        click: function ($event) {
                          return _vm.confirmDeleteCategory()
                        },
                      },
                    },
                    [_c("span", [_vm._v("Confirm")])]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }